import React from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import isString from 'lodash/isString';
import RadioButton from './RadioButton';

export default function RadioGroup({
  name,
  selected,
  onChange,
  options,
  extraStyles,
  buttonExtraStyles,
  isDisabled,
}) {
  return (
    <div style={{ ...extraStyles }}>
      {options.map(button => (
        <RadioButton
          label={button.label}
          name={name}
          onChange={() => onChange(button.value)}
          checked={isEqual(selected, button.value)}
          value={button.value}
          key={!isString(button.label) ? button.value : button.label}
          buttonExtraStyles={buttonExtraStyles}
          isDisabled={isDisabled}
        />
      ))}
    </div>
  );
}

RadioGroup.propTypes = {
  name: PropTypes.string.isRequired,
  selected: PropTypes.any,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]).isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool,
    ]).isRequired,
  })).isRequired,
  extraStyles: PropTypes.object,
  buttonExtraStyles: PropTypes.object,
  isDisabled: PropTypes.bool,
};

RadioGroup.defaultProps = {
  selected: '',
  onChange: () => {},
  extraStyles: {},
  buttonExtraStyles: {},
  isDisabled: false,
};
